export default "__VITE_ASSET__0MCnBxMO__"